import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

// Pages
import Login from "./pages/Login";
import MainLayout from "./components/MainLayout";
import Enquiries from "./pages/Enquiries";
 
import ViewEnq from "./pages/ViewEnq";
import ViewBooking from "./pages/ViewBooking";
 
import Bookings from "./pages/CarwashBookings";
 
 
// Routes
import { PrivateRoutes } from "./routing/PrivateRoutes";
import { OpenRoutes } from "./routing/OpenRoutes";
import WaterRefillBookings from "./pages/WaterRefillBookings";
import CarpetBookings from "./pages/CarpetBookings";
import CarwashBookings from "./pages/CarwashBookings";
import ViewCarpetBookings from "./pages/ViewCarpetBookings";
import Dashboard from "./pages/Dashboard";
import ViewCarwashBookings from "./pages/ViewCarwashBookings";
import ViewWaterRefillBookings from "./pages/ViewWaterRefill";
  
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay (e.g., fetching initial data)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust the timeout as needed

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {loading ? (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          <Routes>
            {/* Public route */}
            <Route
              path="/"
              element={
                <OpenRoutes>
                  <Login />
                </OpenRoutes>
              }
            />

            {/* Private admin routes */}
            <Route
              path="/admin"
              element={
                <PrivateRoutes>
                  <MainLayout />
                </PrivateRoutes>
              }
            >
   
              {/* Enquiries */}
              <Route path="enquiries" element={<Enquiries />} />
              <Route path="enquiries/:id" element={<ViewEnq />} />

              {/* Bookings */}
              <Route path="carwash-bookings" element={<CarwashBookings />} />
                <Route path="carpet-bookings" element={<CarpetBookings />} />
               <Route path="carpet-bookings/:id" element={<ViewCarpetBookings />} />
               <Route path="water-refill" element={<WaterRefillBookings />} />
               <Route path="water-refill/:id" element={<ViewWaterRefillBookings/>} />
               <Route path="dashboard" element={<Dashboard />} />
               <Route path="carwash-bookings/:id" element={<ViewCarwashBookings />} />

         
            </Route>
          </Routes>
        </>
      )}
    </Router>
  );
}

export default App;
